// extracted by mini-css-extract-plugin
module.exports = {"root":"IconExpand_root__3sDAE"};